<div class="relative">
  <div class="bg--image" [ngClass]="imageClass" [ngStyle]="backgroundStyle">
    @if (!imageLoaded) {
      <img
        [src]="image"
        alt="In Progress"
        (load)="onImageLoad()"
        class="image--loader"
      />
    }
    @if (isCancelled) {
      <div class="cancelled-extra-opacity"></div>
    }
    @if (isCancelled) {
      <div class="product-cancelled">Canceled</div>
    }

    @if (featured) {
      <span class="featured">Featured</span>
    }
    @if (!featured && priorityItem) {
      <span class="featured">Priority Item</span>
    }
    @if (recommended) {
      <span class="recommended">Recommended</span>
    }
  </div>
</div>
